<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="noind" id="epigraph" style="margin-top:20px;"><i>A little fire is quickly trodden out;</i></p>
<p class="noind"><i>Which, being suffer’d, rivers cannot quench.</i></p>
</blockquote>
<p class="poem4" style="margin-top:10px;">—William Shakespeare,</p>
<p class="poem4" style="margin-top:10px;"><i>Henry VI</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-epigraph.vue?ae554586